import {
    FormControl,
    Grid,
    Typography,
    OutlinedInput
  } from "@material-ui/core";

const PhoneNumberField = (props) => {
    const {
        classes,
        value,
        handleChange,
        validation,
        error,
        placeholder,
        name,
        titleName,
        disabled,
    } = props;

    return (
        <FormControl className={classes.select}>
        <label>
          <Typography align="left" className={classes.type_color} variant="h6">
            {titleName}
          </Typography>
        </label>
        <OutlinedInput
            disabled={disabled}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            onBlur={validation}
            onKeyUp={validation}
            className={disabled ? classes.borderStyle: ''}
        />
        {error && (
          <Grid>
            <Typography align="left" className={classes.MsgError}>
              {error}
            </Typography>
          </Grid>
        )}
      </FormControl>
    )
}

export default PhoneNumberField;